import { JSX } from 'react';
import { ToggleListItem } from '@bg-components/Modals/TopSettingsModal/List/ToggleListItem';
import { useStore } from '@betgames/bg-state-manager';
import {
    t,
    soundsStore,
    soundsSelectors,
    useMatchedGameId,
    playerSettingsStore,
    playerSettingsSelectors,
    ClassicGameDefinition,
    analyticsApi,
} from '@bg-shared';

export const GameSounds = (): JSX.Element => {
    const gameId = useMatchedGameId();
    const gameSoundsMuted = useStore(soundsStore, soundsSelectors.getGameSoundsMuted);
    const casinoModeEnabled = useStore(playerSettingsStore, playerSettingsSelectors.getCasinoMode);

    const disabled = ClassicGameDefinition.isCasinoView(gameId) && !casinoModeEnabled;

    return (
        <ToggleListItem
            disabled={disabled}
            label={t.string('game_sounds')}
            enabled={!gameSoundsMuted}
            dataQa="area-toggle-game-sounds-list-item"
            onChange={(newValue) => {
                soundsStore.gameSoundsMuted = !newValue;
                analyticsApi.trackGameEffectsSettingSwitch(newValue);
            }}
        />
    );
};
